import api from './api';
import axios from 'axios'
import { TASK_V1_POST_CASES_ADD, TOKEN_LEGAL365, MAILS_SEND_CLIENT } from '../config.js'
import { getConsultantIdentifier } from '../Redux/UsersDucks'
import ErrorService from './errorService';
import Swal from 'sweetalert2';

export const InyeccionService = {
    injectionStart: async (injectionData) => {
        try {
            // Verificar si los datos son correctos
            if (!injectionData || !injectionData.client || !injectionData.cases || !injectionData.documents) {
                throw new Error('Los datos de inyección están incompletos.');
            }

            // Llamada POST al endpoint
            const response = await ErrorService.withTimeout(
                api.post('/Inyector/InjectionStart', injectionData)
            );

            // Mostrar mensaje de éxito
            Swal.fire({
                icon: 'success',
                title: '¡Éxito!',
                text: 'La inyección se realizó correctamente.',
                confirmButtonText: 'Aceptar',
            });

            return response.data;
        } catch (error) {
            // Manejar errores
            ErrorService.handleApiError('Error al iniciar la inyección:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'No se pudo realizar la inyección. Verifica los datos e inténtalo nuevamente.',
                confirmButtonText: 'Aceptar',
            });
            throw error;
        }
    },
    ConfirmInyectionLegal: async (contractId, status, responseInyectionLegal, sendInyectionLegal) => {
        try {
            const consultantIdentifier = getConsultantIdentifier()
            if (!consultantIdentifier)
                throw new Error('Consultor. Se debe de ingresar en el sistema es requerido su rut.');

            const response = await ErrorService.withTimeout(api.post(`/Contract/ConfirmInyectionLegal/${contractId}/${consultantIdentifier}`, {status, sendInyectionLegal, responseInyectionLegal }));
            return response.data;

        } catch (error) {
            ErrorService.handleApiError('Error al obtener:', error);
            throw error;
        }
    },
    ConfirmSendMail: async (contractId, htmlEmail, send) => {
        try {
            const response = await ErrorService.withTimeout(api.post(`/Contract/ConfirmSendMail`, { contractId, htmlEmail, send }));
            return response.data;

        } catch (error) {
            ErrorService.handleApiError('Error al obtener:', error);
            throw error;
        }
    },

    cargarCuotas: async (cuotasData) => {
        try {
            // Validar los datos del cuerpo
            if (!cuotasData || !cuotasData.Pagador) {
                throw new Error('Los datos de las cuotas están incompletos.');
            }

            // Llamada POST al endpoint
            const response = await ErrorService.withTimeout(
                api.post('/Manager/CargarCuotas', cuotasData)
            );

            return true//response.data;
        } catch (error) {
            // Manejar errores
            ErrorService.handleApiError('Error al cargar las cuotas:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'No se pudieron cargar las cuotas. Inténtalo nuevamente.',
                confirmButtonText: 'Aceptar',
            });
            throw error;
        }

    },

    injectionLegalV1: async (DATA) => {
        try {
            const RES = await axios.post(TASK_V1_POST_CASES_ADD, DATA)

            if (RES.status === 200) {
                // Mostrar mensaje de éxito
                Swal.fire({
                    icon: 'success',
                    title: '¡Éxito!',
                    text: 'La inyección se realizó correctamente.',
                    confirmButtonText: 'Aceptar',
                });
                var data = RES.data
                data.status = true;

            } else {
                Swal.fire({
                    icon: 'warning',
                    title: '¡Error!',
                    text: 'La inyección falló.',
                    confirmButtonText: 'Aceptar',
                });
                var data = RES.data
                data.status = false;
            }

        } catch (error) {
            // Manejar errores
            Swal.fire({
                icon: 'warning',
                title: '¡Error!',
                text: 'La inyección falló.',
                confirmButtonText: 'Aceptar',
            });
            var data = {status: false}
        }
        return data;
    },

    SendClientMails: async (body) => {
        try {
            const RES = await axios.post(MAILS_SEND_CLIENT, body)

            if (RES.status === 200) {
                // Mostrar mensaje de éxito
                Swal.fire({
                    icon: 'success',
                    title: '¡Éxito!',
                    text: 'Correos enviados al cliente.',
                    confirmButtonText: 'Aceptar',
                });
                return { html: RES.data, success: true };

            } else {
                Swal.fire({
                    icon: 'warning',
                    title: '¡Error!',
                    text: 'No Se pudo enviar los Correos al cliente.',
                    confirmButtonText: 'Aceptar',
                });
            }
            return { html: "", success: false }
        } catch (error) {
            // Manejar errores
            ErrorService.handleApiError('Error al enviar la actualizacion del negocio a HubSpot:', error)
            return { html: "", success: false }
        }
        return { html: "", success: false }
    },

    saveTasks: async (listTask, type, contractId) => {
        var data = {
            type: type,
            contractId: contractId,
            tasks: JSON.stringify(listTask)
        }
        try {

            // Llamada POST al endpoint
            const response = await ErrorService.withTimeout(api.post('/Causas/saveTasksList', data));
            Swal.fire({
                icon: 'success',
                title: '¡Éxito!',
                text: 'Tareas Almacendas.',
                confirmButtonText: 'Aceptar',
            });

            return true//response.data;
        } catch (error) {
            // Manejar errores
            ErrorService.handleApiError('Error al cargar las cuotas:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'No se pudieron guardar las tareas. Inténtalo nuevamente.',
                confirmButtonText: 'Aceptar',
            });
            throw error;
        }
    },
    getTasks: async (type, contractId) => {
        var data = {
            type: type,
            contractId: contractId,
            tasks: ""
        }
        try {

            // Llamada POST al endpoint
            const response = await ErrorService.withTimeout(api.post('/Causas/getTasksList', data));
            return response.data;
        } catch (error) {
            // Manejar errores
            ErrorService.handleApiError('Error al cargar las cuotas:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'No se pudieron guardar las tareas. Inténtalo nuevamente.',
                confirmButtonText: 'Aceptar',
            });
            throw error;
        }
        return null;
    },
    getTasksCase: async (contractId) => {
        try {
            const response = await ErrorService.withTimeout(api.get('/Causas/getTasksCaseList/'+contractId, ));

            return response.data;
        } catch (error) {
            // Manejar errores
            ErrorService.handleApiError('Error al cargar las cuotas:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'No se pudieron guardar las tareas. Inténtalo nuevamente.',
                confirmButtonText: 'Aceptar',
            });
            throw error;
        }
        return null;
    },
    addCausaListValidate: async (data) => {
        try {
            const consultantIdentifier = getConsultantIdentifier();
            if (!consultantIdentifier) {
                throw new Error('Consultor. Se debe de ingresar en el sistema es requerido su rut.');
            }
            const requestBody = data
            requestBody.createdBy = consultantIdentifier

            const response = await ErrorService.withTimeout(api.post('/Causas/saveCaseTasksList', requestBody));

            // Mostrar mensaje de éxito usando Swal
            if (response.data == true)
                Swal.fire({
                    icon: 'success',
                    title: '¡Éxito!',
                    text: 'Causas registrada correctamente.',
                    confirmButtonText: 'Aceptar'
                });
            else
                Swal.fire({
                    icon: 'warning',
                    title: '¡Error!',
                    text: 'No se guardo la Causa.',
                    confirmButtonText: 'Aceptar'
                });

            return response.data;
        } catch (error) {
            console.error("Error registrando causas:", error.message || error);
            throw error;
        }
    },
};

export default InyeccionService;